import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div<{ $hasTapBar: boolean }>`
  ${flexColumn};
  min-height: 100vh;

  .lotriver-desk-top-banner {
    a img {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  @media (max-width: ${BREAKPOINTS.desktop}) {
    ${({ $hasTapBar }) =>
      $hasTapBar &&
      css`
        padding-bottom: 80px;
      `}
  }
`;

export const MainContent = styled.main`
  flex: 1;
  ${flexColumn};
  padding-top: 70px;
`;
